import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
    collection,
    doc,
    getDoc,
    onSnapshot,
    orderBy,
    query,
    where,
} from "firebase/firestore";
import { auth, db } from "../../firebase";
import Menu from "../../panel/Menu";
import moment from "moment";

// MUI
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Button,
} from "@mui/material";

function Damagenotes() {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
    });

    const [damages, setDamages] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [propertyId, setPropertyId] = useState(null);

    /* ---------------- AUTH + PROPERTY ---------------- */
    useEffect(() => {
        const unsub = auth.onAuthStateChanged(async (user) => {
            if (!user) return;

            const userRef = doc(db, "authroles", user.uid);
            const snap = await getDoc(userRef);

            if (snap.exists()) {
                setPropertyId(snap.data().propertyId);
            }
        });

        return () => unsub();
    }, []);

    /* ---------------- FETCH DAMAGE NOTES ---------------- */
    useEffect(() => {
        if (!propertyId) return;

        const q = query(
            collection(db, "damages"),
            where("propertyId", "==", propertyId),
            orderBy("createdAt", "desc")
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const list = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setDamages(list);
            setFiltered(list);
        });

        return () => unsub();
    }, [propertyId]);

    /* ---------------- SEARCH ---------------- */
    useEffect(() => {
        if (!searchText) {
            setFiltered(damages);
        } else {
            setFiltered(
                damages.filter((d) =>
                    d.customers?.custname
                        ?.toLowerCase()
                        .includes(searchText.toLowerCase())
                )
            );
        }
    }, [searchText, damages]);

    return (
        <>
            <Menu />

            <Box className="content-wrapper p-4" >
                <Typography variant="h5" fontWeight={800} mb={2}>
                    Damage Notes
                </Typography>

                <Paper sx={{ mt: 2, p: 2 }}>
                    <TextField
                        label="Search Customer"
                        size="small"
                        fullWidth
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        sx={{ maxWidth: 400, mb: 2 }}
                    />

                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr No</TableCell>
                                    <TableCell>Customer Name</TableCell>
                                    <TableCell>Mobile</TableCell>
                                    <TableCell align="right">Damage Amount</TableCell>
                                    <TableCell>Damage Note</TableCell>
                                    <TableCell>Date</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {filtered.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            No Records Found
                                        </TableCell>
                                    </TableRow>
                                )}

                                {filtered.map((row, index) => (
                                    <TableRow key={row.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{row.customers?.custname}</TableCell>
                                        <TableCell>{row.customers?.mobile}</TableCell>
                                        <TableCell align="right">
                                            ₹ {Number(row.damageamount).toFixed(2)}
                                        </TableCell>
                                        <TableCell>{row.damagenote}</TableCell>
                                        <TableCell>
                                            {row.createdAt
                                                ? moment(row.createdAt.toDate()).format("DD/MM/YYYY")
                                                : "-"}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
        </>
    );
}

export default Damagenotes; 
